"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorRotate = void 0;

var _react = _interopRequireDefault(require("react"));

var _RotateToPort = _interopRequireDefault(require("../../assets/img/RotateToPort.svg"));

var _atoms = require("../../atoms");

require("./ErrorRotate.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var ErrorRotate = function ErrorRotate() {
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "ErrorSection"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    height: "100%",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true,
    marginBottom: "4"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _RotateToPort.default,
    alt: "Please rotate your device to portrait orientation to use this feature"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Label, null, "Rotate to portrait", /*#__PURE__*/_react.default.createElement("br", null), "to use this feature")));
};

exports.ErrorRotate = ErrorRotate;